import http from './http'
import breadcrumb from './breadcrumb.json'
export default http

export { breadcrumb }
